/* cSpell:disable */
import { HeaderConfig } from '@tenants/types/tenant';
import { RootDomain } from 'constants/domains';
import { LOCALE_EXP_COMMERCIAL_PATHS } from 'types/locales';
export function createHeaderConfig(_rootDomain: RootDomain): HeaderConfig {
  const headerConfig: HeaderConfig = {
    mainButtonCopy: LOCALE_EXP_COMMERCIAL_PATHS.HEADER_MAINBUTTONCOPY,
    authButtonCopy: LOCALE_EXP_COMMERCIAL_PATHS.HEADER_AUTHBUTTONCOPY,
    hasJoinExpPage: true,
    authMenuItems: [
      {
        label: LOCALE_EXP_COMMERCIAL_PATHS.HEADER_AUTHLINKS_MYSAVEDSEARCHES,
        link: '/account/saved/searches',
        id: 'my-saved-searches',
      },
      {
        label: LOCALE_EXP_COMMERCIAL_PATHS.HEADER_AUTHLINKS_MYFAVOURITES,
        link: '/account/saved/favourites',
        id: 'my-favourites',
      },
      {
        label: LOCALE_EXP_COMMERCIAL_PATHS.HEADER_AUTHLINKS_EDITPROFILE,
        link: '/account/details',
        id: 'edit-profile',
      },
      {
        label: LOCALE_EXP_COMMERCIAL_PATHS.HEADER_AUTHLINKS_SIGNOUT,
        id: 'sign-out',
        signOut: true,
      },
    ],
    menuItems: [
      {
        id: 'join',
        label: LOCALE_EXP_COMMERCIAL_PATHS.HEADER_MENULINKS_JOIN,
        link: '/join-us',
      },
      {
        id: 'our-services',
        label: LOCALE_EXP_COMMERCIAL_PATHS.HEADER_MENULINKS_SERVICES,
        link: '/our-services',
      },
      {
        id: 'insights',
        label: LOCALE_EXP_COMMERCIAL_PATHS.HEADER_MENULINKS_INSIGHTS,
        link: '/insights',
      },
      {
        id: 'about-us',
        label: LOCALE_EXP_COMMERCIAL_PATHS['HEADER_MENULINKS_ABOUT-US'],
        link: '/about-us',
      },
    ],
  };

  return headerConfig;
}
